console.log(
    "_____@@______"
);